'use strict';

// Picks the option a product should start on and returns its value.
//
// `is_default` defaults to false in the database, so plenty of products have
// nothing flagged at all - those fall back to the first option.
//
// A variable can also arrive with no options at all: `item_page_option`
// selects the variable while the `enabled` scope filters out every disabled
// option. Return undefined for that rather than throwing.
const defaultOptionValue = (options) => {
  const flagged = options.find(option => option.is_default);

  return (flagged || options[0] || {}).value;
};

export default defaultOptionValue;
